import { render } from "./RealtimePage.vue?vue&type=template&id=fa11dfd8"
import script from "./RealtimePage.vue?vue&type=script&lang=js"
export * from "./RealtimePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__